import { Collaborator } from './collaborators/Collaborator';
import { UserProfile } from './UserProfile';
import { ILanguage, IUser } from './AuthenticationSystem';
import { ClientConfigs } from '../lib/Util';


export class User {
  protected constructor(
      private collaborator: Collaborator,
      private profile: UserProfile,
      private id: string,
      private name: string,
      private email: string,
      private language: ILanguage,
      private col_empp_id: string,
      private clientConfigs: ClientConfigs[]
  ) {}

  static fromIUser(collaborator: Collaborator, profile: UserProfile, user: IUser, clientConfigs: ClientConfigs[]) {
    return new this(collaborator, profile, user.us_id, user.us_nombre, user.us_email, user.language, user.colaborador.col_empp_id, clientConfigs);
  }

  referencesCollaborator(collaborator: Collaborator): boolean {
    return this.collaborator.isIdentifiedAs(collaborator);
  }

  getCollaboratorId() {
    return this.collaborator.getId();
  }

  getCollaborator(): Collaborator {
    return this.collaborator;
  }

  isStandardUser(): boolean {
    return this.profile.isStandardUser();
  }

  isDirectiveUser(): boolean {
    return this.profile.isDirectiveUser();
  }

  isPowerUser(): boolean {
    return this.profile.isPowerUser();
  }

  isAdminUser(): boolean {
    return this.profile.isAdminUser();
  }

  hasPowerUserPrivileges() {
    return this.isPowerUser() || this.isAdminUser();
  }

  getProfile(): UserProfile {
    return this.profile;
  }

  getUserId() {
    return this.id
  }

  getLenguage() {
    return this.language
  }

  getColEmppId() {
    return this.col_empp_id;
  }
  getClientConfigs() {
    return this.clientConfigs;
  }
}
